export class NewLocks {
	constructor(
		public TableId: number,
		public RecordIds: number[]) {
	}
}